import React from 'react';
import Reveal from './Reveal';

const Statement = () => {
  return (
    <section className="py-24 md:py-32 bg-black" data-testid="statement-section">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl text-center">
        <Reveal>
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-white leading-snug mb-8" data-testid="statement-title">
            İş ve Aile Seyahatlerinizde <span className="italic text-yellow-500">Güvenilir Adresiniz</span>
          </h2>
          <p className="text-base md:text-lg text-zinc-400 leading-relaxed font-light" data-testid="statement-text">
            10 yıla dayanan konaklama tecrübemizle, iş gezilerinizde ihtiyacınız olan sessizliği ve aile tatillerinizde aradığınız konforu tek çatı altında buluşturuyoruz. İskenderun'daki yeriniz her zaman hazır.
          </p>
          <div className="w-24 h-px bg-yellow-500 mx-auto mt-10"></div>
        </Reveal>
      </div>
    </section>
  );
};

export default Statement;
